import React, {useState} from 'react';
import Translate, {t} from "../../../../../../../components/Translate";
import BlueButton from "../../../../../../../components-new/buttons/BlueButton";

function ImportTemplates({clients, folders, onImport, user}) {
    const [selectedClientId, setSelectedClientId] = useState('');
    const [selectedFolderName, setSelectedFolderName] = useState('');

    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}>

            <select
                style={{
                    display: 'block',
                    backgroundColor: 'white',
                    border: '1px solid rgb(221, 221, 221)',
                    fontSize: '16px',
                    padding: '10px',
                    borderRadius: '10px',
                }}
                value={selectedClientId}
                onChange={(e) => setSelectedClientId(e.target.value)}
            >
                <option value="">{t({text: 'selectBot', user})}</option>
                {clients.map((c) => (
                    <option key={c.id} value={c.id}>{c.name}</option>
                ))}
            </select>

            <select
                style={{
                    display: 'block',
                    backgroundColor: 'white',
                    border: '1px solid rgb(221, 221, 221)',
                    fontSize: '16px',
                    padding: '10px',
                    borderRadius: '10px',
                }}
                value={selectedFolderName}
                onChange={(e) => setSelectedFolderName(e.target.value || '')}
            >
                <option value="">{t({text: 'allFolders', user})}</option>
                {folders.map((f) => (
                    <option key={f} value={f}>{f}</option>
                ))}
            </select>

            <BlueButton
                width={'170px'}
                height={'43px'}
                styles={{fontSize: '11px'}}
                onClick={() => onImport(selectedClientId, selectedFolderName || null)}
                disabled={!selectedClientId}
            >
                <Translate text={"import"}/>
            </BlueButton>
        </div>
    );
}

export default ImportTemplates;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/ImportTemplates.jsx